<template>
<span class="print-view">
    <div class="btn-group text-center my-4" v-if="!is_full_screen">
        <vs-button class="mx-1 my-1" type="filled" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4" v-bind:style="footerStyleObject">
       <div class="vx-row mb-0">
         <div class="vx-col w-full">

          <main class="clearfix">

            <div id="user" class="clearfix">

              <div id="user-top">

                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                  <tbody>
                  <tr>
                    <td class="">
                      <img id="logo" class="ml-16"
                           src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                           alt="Logo" width="150" height="75"/>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <table id="in-tbl" style="width: 90%">
                        <tr >
                          <td>
                            <div class="head">
                              <b style="color:#000;">SALES QUOTATION</b>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <table id="in-tbl" style="width: 90%">
                        <tr>
                          <td width="50%">
                            <div class="vx-row">
                                <div class="vx-col w-1/2">
                                  <p class="sml"><b>INVOICE ADDRESS</b></p>
                                  <p class="sml">{{ salesQuote.invoice_address.site_name }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.line1 }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.line2 }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.line3 }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.town_state }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.post_code }}</p>
                                  <p class="sml">{{ salesQuote.invoice_address.country }}</p>
                                </div>
                                <div class="vx-col w-1/2">
                                  <p class="sml">VAT: {{ salesQuote.customer_vat || 'N/A' }}</p>
                                  <p class="sml">EORI: {{ salesQuote.customer_eori || 'N/A' }}</p>
                                  <p class="sml">TEL: {{ salesQuote.customer_tel || 'N/A' }}</p>
                                  <p class="sml">IMPORT LICENCE NO: {{ salesQuote.import_licence_no || 'N/A' }}</p>
                                </div>
                              </div>
                          </td>
                          <td width="50%">
                             <table class="" id="in-tbl">
                               <tr>
                                 <td class="pt-4 pb-4">
                                   <div>
                                   <p class="sml"><b>QUOTATION NUMBER</b></p>
                                   <p class="sml">{{salesQuote.quote_code}}</p>
                                   </div>
                                 </td>
                                 <td class="pt-4 pb-4">
                                   <p class="sml"><b>QUOTATION DATE</b></p>
                                   <p class="sml">{{convertDate(salesQuote.created_at)}}</p>
                                 </td>
                               </tr>
                               <tr>
                                 <td class="pt-4 pb-4">
                                   <p class="sml"><b>CUSTOMER ACCOUNT</b></p>
                                   <p class="sml">{{salesQuote.customer_account_number}}</p>
                                 </td>
                                 <td class="pt-4 pb-4">
                                   <p class="sml"><b>TERMS OF PAYMENT</b></p>
                                   <p class="sml">{{salesQuote.terms_of_payment}}</p>
                                 </td>
                               </tr>
                             </table>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%">
                            <div>
                              <p class="sml"><b>DELIVERY ADDRESS</b></p>
                              <p class="sml">{{ salesQuote.delivery_address.site_name }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.line1 }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.line2 }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.line3 }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.town_state }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.post_code }}</p>
                              <p class="sml">{{ salesQuote.delivery_address.country }}</p>
                            </div>
                          </td>
                          <td width="50%">
                            <table class="" id="in-tbl">
                              <tr>
                                 <td class="pt-4 pb-4" width="50%">
                                   <div>
                                      <p class="sml"><b>CURRENCY</b></p>
                                      <p class="sml">{{ salesQuote.customer. account_currency }}</p>
                                    </div>
                                 </td>
                                 <td class="pt-4 pb-4" width="50%">
                                   <p class="sml"></p>
                                 </td>
                               </tr>
                              <tr>
                                 <td class="pt-10 pb-10" width="50%">
                                   <p class="sml"></p>
                                 </td>
                                 <td class="pt-10 pb-10" width="50%">
                                   <p class="sml"></p>
                                 </td>
                               </tr>
                            </table>
                          </td>

                        </tr>
                        <tr>
                          <td width="50%">
                            <div>
                              <p class="sml"><b>F.A.O</b></p>
                              <p class="sml mt-5">{{salesQuote.fao.full_name || ''}}</p>

                            </div>
                          </td>
                          <td width="50%">
                            <div>
                              <p class="sml mt-3 mb-3"><b>ACCOUNT MANAGER:</b> {{salesQuote.account_manager}}</p>
                              <p class="sml mt-5 mb-3"><b>QUOTATION CREATED BY:</b> {{ salesQuote.created_by }}</p>
                            </div>
                          </td>

                        </tr>

                      </table>
                  <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                  <tr>
                    <td colspan="3">
                      <table class="txt-center" id="in-tbl" style="width: 91%">
                        <tr>
                          <td>
                            <div>
                              <p class="sml"><b>Customer Product Code</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Product Code/Name</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Quantity (KG)</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Price/KG ({{ salesQuote.customer. account_currency || '' }})</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Pack Size (KG)</b></p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Lead Time</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Incoterms</b></p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Valid From</b></p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Valid To</b></p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="sml"><b>Estimated Yearly Volume (KG)</b></p>
                            </div>
                          </td>

                        </tr>

                        <tr v-for="(item, index) in salesQuote.items" :key="index">
                          <td>
                            <div>
                              <p>{{ item.customer_product_code }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.product_code_name }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <div>
                                <span v-if="!item.is_tier">
                                  <p>{{ item.quantity[0].quantity }}</p>
                                </span>
                                <span v-else>
                                  <span v-for="(qty_obj, index_obj) in item.quantity" :key="index_obj">
                                     <p>{{ qty_obj.quantity_from }}</p>
                                  </span>
                                </span>
                              </div>

                            </div>
                          </td>
                          <td>
                            <div>

                              <span v-for="(price_obj, index_obj) in item.price" :key="index_obj">
                                <p>{{ price_obj.price }}</p>
                              </span>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.pack_size }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.lead_time }} working days</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.incoterms }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.valid_from }}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.valid_to }}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ item.estimated_yearly_volume != null ? item.estimated_yearly_volume != null : "N/A" }}</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  </tbody>
                </table>
                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0" v-if="salesQuote.add_costs.length > 0">
                  <tbody>
                  <tr>
                    <td colspan="3">
                      <table class="txt-center" id="in-tbl" style="width: 91%">
                        <tr>
                          <td width="40%">
                            <div>
                              <p class="sml"><b>Name/Description</b></p>

                            </div>
                          </td>
                          <td width="30%">
                            <div>
                              <p class="sml"><b>VAT Rate (%)</b></p>

                            </div>
                          </td>
                          <td width="30%">
                            <div>
                              <p class="sml"><b>Net Value ({{ salesQuote.customer. account_currency || '' }})</b></p>

                            </div>
                          </td>
                        </tr>

                        <tr v-for="(item, cost_index) in salesQuote.add_costs" :key="cost_index">
                          <td>
                            <div>
                              <p>{{ item.name }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ Number(item.vat_percent) }}</p>

                            </div>
                          </td>
                          <td>
                            <div>
                              <p>{{ Number(item.amount * (1 + (Number(item.vat_percent) / 100))).toFixed(2) }}</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  </tbody>
                  </table>
             </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-bind:style="styleObject">
            <p style="text-align: justify;text-justify: inter-word" class="ml-2 mr-2">The Quotation is valid for delivery to the Delivery Address Country.
            The Quotation is subject to availability and final confirmation prior to ordering. It is based on market conditions and is subject to change.
            I.T.S. T&C's apply and available on the last page.</p>
            <hr class="mt-4 mb-4">
            <p class="text-center">(I.T.S) International Taste Solutions Ltd, Innovation House, Abex Road, Newbury, Berkshire RG14 5EY. United Kingdom</p>
            <p class="text-center">Tel: +44 (0) 1635 261920 Email: sales@itstaste.com</p>
            <p class="text-center">www.itstaste.com</p>
            </div>

            <div class="mt-10">
              <img id="logo"
                   src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                   alt="Logo" width="10%"/>
              <p><b>Terms of Trading</b></p>
            </div>

            <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                  <div>
                    <tr class="termsText">
                    <td width="50%">
                      <p>1 <b>Business customers and consumers</b></p>
                      <p>1.1 Some of these terms apply to consumers only; some apply to business customers only. Those terms are marked as such.</p>
                      <p>1.3 You are classified as a business customer if you indicate to us that the goods supplied by us will be used in the course of your business or if you use the goods in the course of your business.</p>
                      <p>1.4 If you are not a business customer, you are a consumer. Your have certain statutory rights as a
consumer which are not affected by these terms. Contact your local trading standards office for more
information. Words in italic type are legal words which clarify, rather than alter, the meaning of the
relevant clause.</p>
                      <p><b>2 Prince</b></p>
                      <p>2.1 The price quoted excludes VAT (unless otherwise stated). VAT will be charged at the rate applying at
the time of delivery.</p>
                      <p>2.2 Our quotations lapse after 30 days (unless otherwise stated).</p>
                      <p>2.3 The price quoted excludes delivery (unless otherwise stated).</p>
                      <p><b>2.4 Business customers:</b> unless otherwise stated, the price quoted to business customers is an
illustrative estimate only and the price charged will be our price current at the time of delivery.</p>
                      <p><b>2.5 Business customers:</b> rates of tax and duties on the goods will be those applying at the time of
delivery.</p>
                      <p><b>2.6 Business customers:</b>at any time before delivery we may adjust the price to reflect any increase in
our costs of supplying the goods. </p>
                      <p><b>3 Delivery</b></p>
                      <p>3.1 All delivery times quoted are estimates only.</p>
                      <p>3.2 If we fail to deliver within a reasonable time, you may (by informing us in writing) cancel the contract,
however:</p>
                      <p>3.2.1 you may not cancel if we receive your notice after the goods have been dispatched; and</p>
                      <p>3.2.2 if you cancel the contract, you can have no further claim against us under that contract.</p>
                      <p>3.3 f you accept delivery of the goods after the estimated delivery time, it will be on the basis that you
have no claim against us for delay (including indirect or consequential loss, or increase in the price of
the goods).</p>
                      <p>3.4 We may deliver the goods in instalments. Each instalment is treated as a separate contract.</p>
                      <p><b>4 Delivery and safety</b></p>
                      <p>4.1 We may decline to deliver if:</p>
                      <p>4.1.1 we believe that it would be unsafe, unlawful or unreasonably difficult to do so; or</p>
                      <p>4.1.2 the premises (or the access to them) are unsuitable for our vehicle.</p>
                      <p><b>5 Delivery and risk</b></p>
                      <p>5.1 The goods are at your risk from the time of delivery.</p>
                      <p>5.2 Delivery takes place either:</p>
                      <p>5.2.1 at our premises (if you are collecting them or arranging carriage); or</p>
                      <p>5.2.2 at your premises (if we are arranging carriage).</p>
                      <p>5.3 You must inspect the goods on delivery. Because our product is perishable, if any goods are dam
aged (or not delivered), any claim should be made within 48 hours of delivery and confirmed in
writing within seven days of delivery (or the expected delivery time). You must give us (and any
carrier) a fair chance to inspect the damages goods.</p>
                      <p>5.4 Goods (even goods which you have told us are damaged) must immediately be stored according to
any applicable regulations and in accordance with any specific instructions on the packaging of our
delivery note.</p>
                      <p><b>6 Payment terms</b></p>
                      <p>6.1 You are to pay us cash on delivery unless you have an approved credit account.</p>
                      <p><b>6.2 Business customers:</b>if you have an approved UK business credit account, payment is due no later
than 30 days after the date of our invoice.</p>
                      <p>6.3 If you fail to pay us in full on the due date:</p>
                      <p>6.3.1 we may suspend or cancel future deliveries;</p>
                      <p>6.3.2 we may cancel any discount offered to you;</p>
                      <p>6.3.3 you must pay us interest at the rate set under s.6 of the Late Payment of Commercial Debts (Interest)
Act 1998</p>
                      <p>a calculated (on a daily basis) from the date of our invoice until payment;</p>
                      <p>b compounded on the first day of each month; and</p>
                      <p>c before and after any judgment (unless a court orders otherwise);</p>
                      <p>6.3.4 we may claim fixed sum compensation from you under s.5A of that Act to cover our credit control
overhead costs; and</p>
                      <p>6.3.5 we may recover (under clause 6.8) the cost of taking legal action to make you pay.</p>
                      <p>6.4 f you have an approved business credit account we may withdraw it or reduce your credit limit or
bring forward your due date for payment.</p>
                      <p>6.5 We may take any of those actions in 6.4 at any time and without notice.</p>
                      <p><b>6.6 Business Customers:</b> you do not have the right to set off any money you may claim from us
against anything you may owe us.</p>
                      <p><b>6.7 Consumers:</b>you may only set off money you claim from us against money you owe us with our
written agreement and on such terms as we may state. </p>
                      <p>6.8 While you owe money to us, we have a right to keep any property we may hold of yours until you
have paid us in full (a lien).</p>
                      <p>6.8 You are to indemnify us in full and hold us harmless from all expenses and liabilities we may incur
(directly or indirectly and including finance costs and legal costs on a full indemnity basis) following
any breach by you of any of your obligations under these terms.</p>
                      <p>6.9 Consumers: clause 6.9 means that you are liable to us for losses we incur because you do not
comply with these terms. We may claim those losses from you at any time and if we have to take
legal action we will ask the court to make you pay our legal costs.</p>
                      <p><b>7 Title</b></p>
                      <p><b>7.1 Consumers: </b>your statutory rights are unaffected.</p>
                      <p>7.2 Business customers: until you pay all debts you may owe us:</p>
                      <p>7.2.1 all goods supplied by us remain our property;</p>
                      <p>7.2.2 you must store them so that they are clearly identifiable as our property;</p>
                      <p>7.2.3 you must insure them (against the risks for which a prudent owner would insure them) and hold the
policy on trust for us;</p>
                      <p>7.2.4 you may use those goods and sell them in the ordinary course of your business, but not if:</p>
                      <p>a. we revoke that right (by informing you in writing); or</p>
                      <p>b. you become insolvent.</p>
                      <p>7.3 If the goods supplied under these terms become mixed with other goods:</p>
                      <p>7.3.1 We own a proportionate part (by value) of the mixture; and</p>
                      <p>7.3.2 When part of the mixture is removed:</p>
                      <p>a. Goods added to the mixture before ours are treated as removed before ours; and</p>
                      <p>b. Goods added to the mixture after ours are treated as removed after ours.</p>
                      <p><b>7.4 Business customers:</b> you must inform us (in writing) immediately if you become insolvent.</p>
                      <p><b>7.5 Business customers:</b> f your right to use and sell the goods ends you must allow us to remove the
goods.</p>
                      <p><b>7.6 Business customers:</b> we have your permission to enter any premises where the goods may be
stored:</p>
                      <p>7.6.1 at any time, to inspect them; and</p>
                      <p>7.6.2 after your right to use and sell them has ended, to remove them, using reasonable force if necessary.</p>
                      <p>7.7 Despite our retention of title to the goods, we have the right to take legal proceedings to recover the
price of goods supplied should you not pay us by the due date.</p>
                      <p>7.8 You are not our agent. You have no authority to make any contract on our behalf or in our name.</p>
                      <p><b>8 Warranties</b></p>
                      <p>8.1 We warrant that the goods (as long as you comply with clause 8.4):</p>
                      <p>8.1.1 comply with their description on our acknowledgement of order form;</p>
                      <p>8.1.2 comply with the requirements of the Food Safety Act 1990; and</p>
                      <p>8.1.3 are free from material defect and will remain so until our stated “use by date” (if any)</p>
                      <p><b>8.2 Business customers:</b> we give no other warranty (and exclude any warranty, term or condition that would otherwise be implied) as to the quality of the goods or their fitness for any purpose.</p>
                      <p><b>8.3 Consumers:</b> the warranty in clause 8.1 is in addition to your statutory rights.
If you believe that we have delivered goods which are do not comply with these warranties, you
must:</p>
                      <p>8.4.1 inform us (in writing), with full details, as soon as possible; and</p>
                      <p>8.4.2 allow us to investigate (we may need access to your premises and product samples).</p>
                      <p>8.5 If the goods are found not to comply with our warranties (following our investigations), and you have
complied with those conditions (in clause 8.4) in full, we will (at our option) replace the goods or
refund the price.</p>
                      <p>8.6 We are not liable for any other loss or damage (including indirect or consequential loss, financial loss,
loss of profits or loss of use) arising from the contract or the supply of goods or their use, even if we
are negligent.</p>
                      <p>8.7 Our total liability to you (from one single cause) for damage to property caused by our negligence is
limited to £1 million.</p>
                      <p>8.8 For all other liabilities not referred to elsewhere in these terms our liability is limited in damages to
the price of the goods.</p>
                      <p>8.9 Nothing in these terms restricts or limits our liability for death or personal injury resulting from
negligence.</p>
                    </td>
                    <td width="50%">
                      <p><b>9 Specification</b></p>
                      <p>9.1 If we prepare the goods in accordance with your specifications or instructions (or using your tools or
materials):</p>
                      <p>9.1.1 you must ensure that the specifications or instructions are accurate and your tools and materials of
good quality; and</p>
                      <p>9.1.2 you must ensure that goods prepared in accordance with those specifications or instructions (or
using your tools and materials) will be fit for the purpose for which you intend to use them.</p>
                      <p>9.2 We reserve the right to make any changes in the specifications of our goods which are necessary to
ensure they conform with any applicable safety or other statutory requirements.</p>
                      <p>9.2 Business customers: we also reserve the right to make without notice any minor modifications in our
specifications designs or materials as we think necessary or desirable</p>
                      <p>9.3 If you sell the goods you must not remove any “use by date”, label or instructions attached to the
goods or their packaging.</p>
                      <p><b>9.4 Business customers:</b> We are not liable to you for any loss caused by you relying on any advice
about the storage or use of the goods which we give you unless it is confirmed in writing by us.</p>
                      <p><b>10 Return of goods</b></p>
                      <p>10.1 We will accept the return of goods from you only:</p>
                      <p>10.1.1 by prior arrangement (confirmed in writing);</p>
                      <p>10.1.2 on payment of an agreed handling charge (unless the goods were defective when delivered) and</p>
                      <p>10.1.3 where the goods are as fit for sale on their return as they were on delivery.</p>
                      <p><b>11 Export terms</b></p>
                      <p>11.1 Where the goods are supplied by us to you by way of export from the United Kingdom Clause 10 of
these terms applies (except to the extent that it is inconsistent with any written agreement between
us).</p>
                      <p>11.2 The ‘Incoterms’ of the International Chamber of Commerce which are in force at the time when the
contract is made apply to exports, but these terms prevail to the extent that there is any
inconsistency.</p>
                      <p>11.3 Unless otherwise agreed, the goods are supplied ex works.</p>
                      <p>11.4 Where the goods are to be sent by us to you by a route including sea transport we are under no
obligation to give a notice under section 32(3) of the Sale of Goods Act 1979.</p>
                      <p>11.5 You are responsible for arranging testing and inspection of the goods at our premises before
shipment (unless otherwise agreed). We are not liable for any defect in the goods which would be
apparent on inspection unless a claim is made before shipment. We are not liable for any damage
during transit.</p>
                      <p>11.6 We are not liable for death or personal injury arising from the use of the goods delivered in the
territory of another State (within the meaning of s.26 (3) (b) Unfair Contract Terms Act 1977).</p>
                      <p><b>12 Cancellation</b></p>
                      <p>12.1 If the order is cancelled (for any reason) you are then to pay us for all stock (finished or unfinished)
we may then hold (or to which we are committed) for the order.</p>
                      <p>12.2 We may suspend or cancel the order, by written notice if:</p>
                      <p>12.2.1 you fail to pay us any money when due (under the order or otherwise);</p>
                      <p>12.2.2 you become insolvent;</p>
                      <p>12.2.3 you fail to honour your obligations under these terms.</p>
                      <p>12.3 You may not cancel the order unless we agree in writing (and clauses 3.2.2 and 12.1 then apply).</p>
                      <p><b>13 Waiver and variations</b></p>
                      <p>13.1 Any waiver or variation of these terms is binding in honour only unless:</p>
                      <p>13.1.1 made (or recorded) in writing;</p>
                      <p>13.1.2 signed on behalf of each party; and</p>
                      <p>13.1.3 expressly stating an intention to vary these terms.</p>
                      <p>13.2 All orders that you place with us will be on these terms (or any that we may issue to replace them).
By placing an order with us, you are expressly waiving any printed terms you may have to the extent
that they are inconsistent with our terms.</p>
                      <p><b>14 Force majeure- business customers only</b></p>
                      <p>14.1 If we are unable to perform our obligations to you (or able to perform them only at unreasonable
cost) because of circumstances beyond our control, we may cancel or suspend any of our obligations
to you, without liability.</p>
                      <p>14.2 Examples of those circumstances include act of God, accident, explosion, fire, flood, transport delays,
strikes and other industrial disputes and difficulty in obtaining supplies.</p>
                      <p><b>15 General</b></p>
                      <p>15.1 English law is applicable to any contract made under these terms. The English and Welsh courts have
non-exclusive jurisdiction.</p>
                      <p>15.2 If you are more than one person, each of you is liable for all of your obligations under these terms
(joint and several liability).</p>
                      <p>15.3 If any of these terms are unenforceable as drafted:</p>
                      <p>15.3.1 it will not affect the enforceability of any other of these terms; and</p>
                      <p>15.3.2 if it would be enforceable if amended, it will be treated as so amended.</p>
                      <p>15.4 We may treat you as insolvent if:</p>
                      <p>15.4.1 you are unable to pay your debts as they fall due; or</p>
                      <p>15.4.2 you (or any item of your property) becomes the subject of:</p>
                      <p>a. any formal insolvency procedure (examples of which include receivership, liquidation, administration,
voluntary arrangements (including a moratorium) or bankruptcy);</p>
                      <p>b. any application or proposal for any formal insolvency procedure; or</p>
                      <p>c. any application, procedure or proposal overseas with similar effect or purpose.</p>
                      <p><b>15.5 Business customers:</b>all brochures, catalogues and other promotional materials are to be treated
as illustrative only. Their contents form no part of any contract between us and you should not rely
on them in entering into any contract with us.</p>
                      <p>15.6 Business customers: any notice by either of us which is to be served under these terms may be
served by leaving it at or by delivering it to (by first class post or by fax) the other's registered office
or principal place of business. All such notices must be signed.</p>
                      <p>15.7 No contract will create any right enforceable (by virtue of the Contracts (Rights of Third Parties) Act
1999) by any person not identified as the buyer or seller.</p>
                      <p>15.8 The only statements upon which you may rely in making the contract with us are those made in
writing by someone who is (or whom you reasonably believe to be) our authorised representative
and either:</p>
                      <p>15.8.1 contained in our estimate (or any covering letter) and not withdrawn before the contract is made;
or</p>
                      <p>15.8.2 which expressly state that you may rely on them when entering into the contract</p>
                      <p>15.9 Nothing in these terms affects of limits our liability for fraudulent misrepresentation</p>
                      <p><b>16 Privacy Policy</b></p>
                      <p>16.1 We are committed to protecting your privacy. Please refer to our Privacy Policy for details on how we collect, use, and
protect your information.</p>
                      <p><b>17 Intellectual Property</b></p>
                      <p>17.1 All intellectual property rights in our products, services, and any related materials are owned by us. You must not use any
of our intellectual property without our prior written consent.</p>
                      <p><b>18 Dispute Resolution</b></p>
                      <p>18.1 Any disputes arising out of or in connection with these terms shall be resolved through negotiation in good faith. If the
dispute cannot be resolved by negotiation, it shall be referred to mediation in accordance with the CEDR Model Mediation
Procedure. If the dispute is not resolved by mediation, it shall be subject to the jurisdiction of the courts as set out in clause
15.1.</p>
                      <p><b>19 Refund and Return Policy</b></p>
                      <p>19.1 We will process refunds in accordance with our Refund and Return Policy.</p>
                      <p><b>20 Compliance with Laws</b></p>
                      <p>20.1 Both parties shall comply with all applicable laws and regulations in the performance of their obligations under these
terms.</p>
                      <p><b>21 Changes to Terms</b></p>
                      <p>21.1 We reserve the right to change these terms at any time. Any changes will be communicated to you in writing and will
become effective 30 days after such notice.</p>
                      <p><b>22 Electronic Communications</b></p>
                      <p>22.1 You agree to receive communications from us electronically. We will communicate with you by email or by posting
notices on our website.</p>
                    </td>
                  </tr>
                  </div>
                  </tbody>
            </table>
          </main>
         </div>
       </div>
    </page>
</span>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import moment from "moment";
import ErrorMessages from "@/mixins/ErrorMessages";
const CustomerRepository = RepositoryFactory.get('customer')


export default {
  name: "SalesQuotePrintView",
  data () {
    return{
      secret_code: '',
      is_full_screen: false,
      salesQuote: {
        delivery_address: {},
        add_costs: []
      }
    }
  },
  async mounted() {
    this.secret_code = this.$route.params.key
    this.is_full_screen = this.$route.query.is_full_screen === null
    await this.getInvoiceDetails()
  },
  methods:{
    async getInvoiceDetails() {
      await this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getSalesQuoteData(this.secret_code)
        this.salesQuote = data.data
        if(this.salesQuote.is_delivery_same_as_invoice_address) {
          this.salesQuote.delivery_address = this.salesQuote.invoice_address
        }
      } catch (e) {
        this.showWarningMessage('Sales quote url is invalid. Please contact admin!')
        await this.$router.push(`/`).then(() => { location.reload() })
      }
      this.$vs.loading.close()
    },
    onClickPrint(){
      window.print()
    },
    convertDate(date){
      return moment(date).format('DD/MM/YYYY')
    }
  },
  mixins: [ ErrorMessages ],
  computed:{
    footerStyleObject: () => {
      // const width = document.getElementById('printDiv').offsetWidth;
    },
    styleObject: function () {
      const total_item_height = this.salesQuote.items.length * 55
      const total_add_cost_height = this.salesQuote.add_costs.length * 55
      const space_height = 550 - (total_item_height + total_add_cost_height)
      return {
        'margin-top': `${space_height}px`
      }
    }
  }
}
</script>

<style lang="scss">

//.ordered_list { counter-reset: item }
//.list_item { display: block }
//.list_item:before { content: counters(item, ".") " "; counter-increment: item}

.termsText > td > p {
  font-size: 10px;
  line-height: 12px;
}

page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  font-family: Cambria, Georgia, serif; font-size: 15px; font-style: normal; font-variant: normal; font-weight: 400; line-height: 20px;
}

page[size="A4"] {
  width: 30cm;
  height: auto;
}

@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}


html,
body {
  -webkit-print-color-adjust: exact !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000 !important;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
  color: #000000 !important;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 5em auto 2em auto;
}

div#user-top table {
  margin: 0 auto .8em auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 8px;
  font-size: 18px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;
  padding: 0 !important;
}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

</style>

